import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Header, Button } from 'semantic-ui-react';

export default function WindcavePaymentStatusPage(){

    const paymentToken = useSelector((state) => state.paymentToken);
    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            {
                paymentToken && paymentToken.payment &&
                <Grid.Row>
                    {
                        paymentToken.payment.result &&
                    <div>
                        <Header size="large" color="green">Success!</Header>
                        <Header size="medium">Your payment details have been saved.</Header>
                    </div>
                    }
                    {
                        !paymentToken.payment.result &&
                    <div>
                        <Header size="large">Unfortunately your payment cannot be processed as your transaction has been declined.</Header>
                        <Header size="medium">Please attempt your purchase again</Header>
                        <a href={paymentToken.payment.retry_url}><Button basic color="black" content="Retry Payment"/></a>
                    </div>
                    }
                </Grid.Row>
            }
            {
                paymentToken && paymentToken.payment === null &&
                <Grid.Row>
                    <Grid.Column>
                        <Header size="large">Something went wrong! Please contact help desk.</Header>
                    </Grid.Column>
                </Grid.Row>
            } 
        </Grid>
    );
}